import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const gamemodesSearchSchema = z.object({
  gametype_id: z.coerce.number().int().positive().optional(),
})

export const Route = createFileRoute('/_layout/plo-solution-upload/gamemodes')({
  validateSearch: gamemodesSearchSchema,
})
